import { CreateUIAnalyticsEvent } from "@atlaskit/analytics-next";

import { ConfirmationPageType } from "../hooks/use-confirmation-page-type";

export const trackPerceivedProvisioningEvent = ({
    createAnalyticsEvent,
    productKey,
    finalProvisioningScreen,
    actionSubject = "perceivedProvisioningScreen",
    startTimeSeconds = Date.now() / 1000
}: {
    createAnalyticsEvent: CreateUIAnalyticsEvent;
    productKey?: string;
    finalProvisioningScreen?: ConfirmationPageType;
    actionSubject?: string;
    startTimeSeconds?: number;
}) => {
    try {
        const startTime = startTimeSeconds;
        const endTime = Date.now() / 1000;
        const timeSpentSeconds = Math.round(endTime - startTime);

        createAnalyticsEvent({
            eventType: "track",
            action: "viewed",
            actionSubject,
            attributes: {
                startTimeSeconds: startTime,
                endTimeSeconds: endTime,
                timeSpentSeconds,
                productKey,
                finalProvisioningScreen
            },
            containerId: "perceivedProvisioningPage"
        }).fire();
    } catch (error) {
        console.error("trackEvent:", error);
    }
};

export const trackGetProvisioningStatusLatencyEvent = ({
    createAnalyticsEvent,
    productKey,
    provisioningScreenOnComplete,
    fetchType = "polling",
    startTimeSeconds = Date.now() / 1000,
    elapsedTimeSeconds
}: {
    createAnalyticsEvent: CreateUIAnalyticsEvent;
    productKey?: string;
    fetchType?: "polling" | "graphql-webhook";
    provisioningScreenOnComplete?: ConfirmationPageType;
    startTimeSeconds?: number;
    elapsedTimeSeconds?: number;
}) => {
    if (!elapsedTimeSeconds) {
        const startTime = startTimeSeconds;
        const endTime = Date.now() / 1000;
        elapsedTimeSeconds = Math.round(endTime - startTime);
    }

    try {
        createAnalyticsEvent({
            eventType: "track",
            action: "loaded",
            actionSubject: "getProvisioningStatusLatency",
            attributes: {
                elapsedTimeSeconds,
                productKey,
                provisioningScreenOnComplete,
                fetchType
            },
            containerId: "perceivedProvisioningPage"
        }).fire();
    } catch (error) {
        console.error("trackEvent:", error);
    }
};
